var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{key:this.loading.key,attrs:{"columns":_vm.columns,"rowKey":function (record) { return record.id; },"dataSource":_vm.list,"pagination":false,"loading":this.loading.effects['domainname/select'] || this.loading.effects['domainname/delete']},scopedSlots:_vm._u([{key:"operation",fn:function(text,record){return [_c('router-link',{staticClass:"mr10",attrs:{"to":{
                path:'detail',
                query: {
                    id: record.id,
                    //这里注意this的作用域指向问题
                    referer: JSON.stringify(_vm.that.$route.query),
                }
            }}},[_vm._v("详情")]),_c('router-link',{staticClass:"mr10",attrs:{"to":{
                path:'edit',
                query: {
                    id: record.id,
                    //这里注意this的作用域指向问题
                    referer: JSON.stringify(_vm.that.$route.query),
                }
            }}},[_vm._v("编辑")]),_c('a-popconfirm',{attrs:{"title":"确认删除?"},on:{"confirm":function () { return _vm.onDelete(record); }}},[_c('a',{attrs:{"disabled":_vm.that.loading.effects['domainname/delete'],"href":"javascript:;"}},[_vm._v("删除")])])]}}])}),(_vm.pagination.total > 0)?_c('v-pageinfo',{attrs:{"pagination":_vm.pagination}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }